import { ArrowRight } from "lucide-react";
import { Container, Eyebrow, Section, Reveal } from "./common";
import { FLUJOS, MUNDO } from "../data/content";

export const MetodoNodo = () => {
  return (
    <Section id="metodo" alt>
      <Container>
        <Reveal>
          <Eyebrow>La metodología</Eyebrow>
          <h2 className="mt-5 font-serif font-light text-3xl sm:text-4xl lg:text-5xl tracking-tight text-stone-100">
            Método <span className="text-rc-sage italic">NODO</span>
          </h2>
          <p className="mt-6 max-w-3xl text-stone-400 font-light leading-relaxed">
            El aislamiento territorial es el problema estructural: cada actor optimiza su parcela y el
            conjunto no avanza. El <span className="text-stone-200">Método NODO</span> —Nodos de Desarrollo
            Regenerativo Territorial— organiza a los actores de un territorio bajo una gobernanza vinculante
            para que produzcan, comercien y conserven como un solo sistema.
          </p>
        </Reveal>

        <Reveal delay={0.1}>
          <div className="mt-10 flex flex-wrap gap-3">
            {FLUJOS.map((f) => (
              <span
                key={f}
                className="px-4 py-2 rounded-full border border-rc-border bg-rc-card text-sm text-stone-300 hover:border-rc-sage/50 hover:text-rc-sage transition-colors"
              >
                {f}
              </span>
            ))}
          </div>
        </Reveal>

        <Reveal delay={0.15}>
          <div className="mt-12 p-8 md:p-10 rounded-2xl bg-rc-card border border-rc-border max-w-3xl">
            <div className="rc-eyebrow">El CTR</div>
            <h3 className="mt-3 font-serif text-xl text-stone-100">
              Una gobernanza que sobrevive a los cambios de administración
            </h3>
            <p className="mt-3 text-stone-400 font-light leading-relaxed">
              El Comité Territorial Regenerativo es la figura que da continuidad al territorio: una interfaz
              institucional estable que articula a productores, comercios, municipios y sociedad civil bajo un
              mismo propósito.
            </p>
            <a
              href="/#biblioteca"
              data-testid="metodo-biblioteca-btn"
              className="mt-6 group inline-flex items-center gap-2 text-sm text-rc-sage hover:text-rc-forestlight transition-colors"
            >
              Leer la metodología completa
              <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
            </a>
          </div>
        </Reveal>

        <div className="mt-24">
          <Reveal>
            <Eyebrow>Posicionamiento global · 2026</Eyebrow>
            <h2 className="mt-5 font-serif font-light text-2xl sm:text-3xl lg:text-4xl tracking-tight text-stone-100 max-w-3xl">
              El mundo tiene las piezas. Nosotros, <span className="text-rc-sage italic">el ensamblaje</span>.
            </h2>
          </Reveal>

          <div className="mt-12 grid md:grid-cols-2 gap-6 lg:gap-8">
            {MUNDO.map((m, i) => (
              <Reveal key={m.title} delay={(i % 2) * 0.1}>
                <div className="h-full p-8 rounded-2xl bg-rc-bg2 border border-rc-border">
                  <h3 className="font-serif text-xl text-stone-100">{m.title}</h3>
                  <div className="mt-5 space-y-4">
                    <div>
                      <div className="text-xs font-mono uppercase tracking-wider text-stone-500">El mundo</div>
                      <p className="mt-1 text-sm text-stone-400 font-light leading-relaxed">{m.mundo}</p>
                    </div>
                    <div className="pt-4 border-t border-rc-border">
                      <div className="text-xs font-mono uppercase tracking-wider text-rc-sage">El NODO</div>
                      <p className="mt-1 text-sm text-stone-300 font-light leading-relaxed">{m.nodo}</p>
                    </div>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </Container>
    </Section>
  );
};
